<template>
  <div class="sent-notification-sidepanel p-3">
    <div class="title text-center d-flex justify-content-between mb-2">
      <span v-if="notification && !notification.predefinedCustomNotification">{{ $t('diagnosis.notificationsModal.customNotification') }}</span>
      <span v-else>{{ $t('diagnosis.notificationsModal.predefinedNotification') }}</span>
      <b-button
        v-shortkey="['shift', 'esc']"
        class="btn__icon btn__icon--primary p-0 pr-0"
        @click="$emit('closeInfoSidepanel')"
        @shortkey.prevent="$emit('closeInfoSidepanel')"
      >
        <i
          class="far fa-times"
          aria-hidden="true"
        />
      </b-button>
    </div>
    <div class="mt-4 sidepanel-subject">
      <h6>{{ notification.subject }}</h6>
    </div>
    <div class="sidepanel-date d-flex align-items-center">
      <i
        class="far fa-calendar mr-2"
        aria-hidden="true"
      /> {{ notification.timestamp | datetime }}
    </div>
    <div class="sidepanel-text">
      <span v-html="notification.body" />
    </div>
    <div class="sidepanel-destination mt-4">
      <div>
        <h6 class="main">
          <i
            class="fal fa-user-friends mr-2"
            aria-hidden="true"
          />
          {{ $t('diagnosis.notificationsModal.recipients') }}
        </h6>
      </div>
      <div class="info-block mt-3">
        <div class="form-label">
          <label>{{ $t('diagnosis.notificationsModal.requester') }}</label>
        </div>
        <span
          v-if="notification.notifiedPetitioner"
          class="dark d-block"
        >{{ notification.notifiedPetitioner.fullName }}</span>
        <span v-else>-</span>
      </div>
      <div class="info-block mt-3">
        <div class="form-label">
          <label>{{ $t('diagnosis.notificationsModal.requesterUnit') }}</label>
        </div>
        <span
          v-if="notification.notifiedDepartment"
          class="dark"
        >{{ notification.notifiedDepartment.name }}</span>
        <span v-else>-</span>
      </div>
      <div class="info-block mt-3">
        <div class="form-label">
          <label>{{ $t('diagnosis.notificationsModal.serviceResponsibilities') }}</label>
        </div>
        <div v-if="notification.notifiedResponsibilities.length">
          <span
            v-for="responsibility in notification.notifiedResponsibilities"
            :key="responsibility.id"
            class="dark d-block"
          >
            {{ responsibility.translatedName }}
          </span>
        </div>
        <span v-else>-</span>
      </div>
      <div class="info-block mt-3">
        <div class="form-label">
          <label>{{ $t('diagnosis.notificationsModal.servicePersonnel') }}</label>
        </div>
        <div v-if="notification.notifiedPersonnelList.length">
          <span
            v-for="requester in notification.notifiedPersonnelList"
            :key="requester.id"
            class="dark d-block"
          >
            {{ requester.fullName }}
          </span>
        </div>
        <span v-else>-</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'CustomSentNotificationsSidepanel',
    props: {
        notification: Object
    }
}
</script>

<style scoped>

</style>
